export default "__VITE_ASSET__BbcRsu7e__"